<template>
  <div class="e-l">
    <!-- 遮罩层 -->
    <div class="mask"></div>
    <!--  情商语文-->
    <div v-show="status === 0" class="item">
      <div :class="['title', status === 0 ? 'animated fadeInUp' : '']">
        <div class="big">情商语文</div>
        <div class="small">让孩子会学语文，会生活！</div>
      </div>
      <div :class="['con', status === 0 ? 'animated fadeInUp' : '']">
        情商语文体系以“会学语文，会生活”为核心理念，立足语文学科核心素养，遵循语文学科教育规律，强化语文学习的实践性，重视孩子“向上，向善，向爱，向美”的人格塑造，是一套理念独创、内容完备、特色鲜明的综合性语文课程体系。
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['status']
};
</script>
<style lang="less">
.e-l {
  height: 100%;
  width: 100%;
  background: url(../../assets/images/e-l.png) center no-repeat;
  position: relative;
  background-size: cover;
  .mask {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    background: rgba(0, 0, 0, 1);
    opacity: 0.6;
    height: 100%;
    width: 100%;
    filter: alpha(opacity=60);
  }
  .item {
    position: relative;
    z-index: 2;
  }
  .title {
    animation-delay: 0.8s;
  }
  .big {
    font-size: 60px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 500;
    line-height: 102px;
    color: rgba(255, 255, 255, 1);
  }
  .small {
    font-size: 40px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 60px;
    color: rgba(204, 204, 204, 1);
    margin: 64px 0;
  }
  .con {
    animation-delay: 1.3s;
    width: 60%;
    font-size: 20px;
    font-family: "PingFang SC", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
    font-weight: 400;
    line-height: 34px;
    color: rgba(204, 204, 204, 1);
    margin: auto;
  }
}
</style>
